import { render, staticRenderFns } from "./kpsrRiskType.vue?vue&type=template&id=eacec174"
import script from "./kpsrRiskType.vue?vue&type=script&lang=js"
export * from "./kpsrRiskType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eacec174')) {
      api.createRecord('eacec174', component.options)
    } else {
      api.reload('eacec174', component.options)
    }
    module.hot.accept("./kpsrRiskType.vue?vue&type=template&id=eacec174", function () {
      api.rerender('eacec174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/base/kpsrRiskType.vue"
export default component.exports